import { useNavigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import { UserTestLessonStore } from '../userTestLessons/userTestLessonStore.ts'
import { urls } from '../../shared/urls.ts'
import Rive, { Fit, Layout } from '@rive-app/react-canvas'
import { motion } from 'framer-motion'
import { BottomButtons, IButtonProp } from '../../shared/ui/bottomButtons.tsx'
import { FormattedMessage } from 'react-intl'

export const UserTestCompleted = ({
  store,
}: {
  store: UserTestLessonStore
}) => {
  const navigate = useNavigate()
  const state = useSnapshot(store.state)

  const correctCount = state.testCompleted.correctCount
  const totalCount = state.testCompleted.totalCount

  const continueButtonProps: IButtonProp = {
    handler: () => {
      navigate(urls.testMode)
    },
    textId: 'Continue',
    bg: 'black-gradient',
    visible: true,
    withIcon: true,
  }

  return (
    <div className="fixed left-0 top-0 z-20 flex h-[100dvh] w-full flex-col items-center justify-between bg-blue6 backdrop-blur-20">
      <Rive
        className="pointer-events-none absolute z-40 size-full"
        src="/animations/confetti.riv"
        layout={new Layout({ fit: Fit.Cover })}
      />
      <div className="relative z-50 flex h-full w-full flex-col items-center justify-between px-24 pb-40 pt-80">
        <motion.div
          className="flex flex-col items-center text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="text-48 font-extrabold text-black">
            <FormattedMessage id="test.completed" />
          </div>
          <div className="mt-32 text-24 font-bold text-black">
            <FormattedMessage
              id="test.result"
              values={{
                correct: correctCount,
                total: totalCount,
              }}
            />
          </div>
        </motion.div>

        <BottomButtons
          firstButtonProps={continueButtonProps}
          secondButtonProps={undefined}
          thirdButtonProps={undefined}
        />
      </div>
    </div>
  )
}
